import { render, staticRenderFns } from "./EditBusinessDis.vue?vue&type=template&id=586fec6e&scoped=true"
import script from "./EditBusinessDis.vue?vue&type=script&lang=js"
export * from "./EditBusinessDis.vue?vue&type=script&lang=js"
import style0 from "./EditBusinessDis.vue?vue&type=style&index=0&id=586fec6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586fec6e",
  null
  
)

export default component.exports